<template>
    <v-dialog v-bind="$attrs" persistent content-class="modal-dialog">
        <v-card class="modal-message">
            <div class="common-text text-center mb-5">
                Интернет-соединение потеряно
            </div>
            <div class="main-text text-center mb-5">
                Проверьте подключение к интернету и повторите попытку
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalConnect",
}
</script>
